import { RequestMethodsEnum as u } from "@systemeio/util";
import { useBuyOffer as r } from "../../../pages/checkout/api/index.mjs";
import { useFetch as c } from "../../../utils/http-client.mjs";
const O = () => {
  const { buyOffer: i, isFetching: n } = r(), { buyOffer: f, isFetching: s } = r(), { fetcher: o, isFetching: m } = c({
    method: u.get
  });
  return {
    stripeBuyOffer: (e, t) => i(e, t),
    stripeCardBuyOffer: (e, t) => f(e, t),
    confirmPaymentIntent: () => o("api/payment/confirm"),
    isFetching: n || s || m
  };
};
export {
  O as useStripeApi
};
